<template>
  <router-link
    :class="$style.panel"
    :to="{path: `/${division.name}`}"
    tag="div">
    <div :class="$style.logoWrapper">
      <img
        :class="$style.logo"
        :src="url"
        :alt="division.name"></div>
    <div :class="$style.divName">{{ division.name }}</div>
  </router-link>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'Panel',
  props: {
    division: {
      type: Object,
      required: true,
    },
  },
  computed: {
    url() {
      return require(`../../assets/logos/${this.division.logo}`);
    },
  },
};
</script>
<style lang="scss"
       module>
@import "src/brand/brandColors.variables";

.panel {
  display: flex;
  flex-flow: column nowrap;
}

.logoWrapper {
  padding: 6.4em 9.6rem;
  width: 100%;
  min-height: 24rem;
  max-width: 37.6rem;
  border: 1px solid $gray-light;
  border-top-left-radius: 0.6rem;
  border-top-right-radius: 0.6rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  width: 100%;
  min-width: 18.2rem;
}

.divName {
  width: 100%;
  max-width: 37.6rem;
  text-align: right;
  background: $gray-light;
  padding: 3rem 4.3rem;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  margin-bottom: 1.6rem;
  composes: standard from "src/brand/typography.scss";
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
